import { Overline } from "@/components/Reveal";
import { motion } from "framer-motion";

export default function PageHero({ overline, title, subtitle, image, height = "min-h-[52vh]" }) {
  return (
    <section className={`relative ${height} flex items-end overflow-hidden pt-24`}>
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#102a3e] via-[#102a3e]/80 to-[#102a3e]/45" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#102a3e]/90 to-transparent" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pb-14 w-full">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          {overline && <div className="overline mb-4 !text-accent">{overline}</div>}
          <h1 className="font-display font-extrabold tracking-tight leading-tight text-4xl sm:text-5xl lg:text-6xl text-white max-w-4xl text-balance">
            {title}
          </h1>
          {subtitle && <p className="mt-5 text-base sm:text-lg text-white/80 max-w-2xl leading-relaxed">{subtitle}</p>}
        </motion.div>
      </div>
    </section>
  );
}
